<template>
    <card-grid-item
        :tab-widget="tabWidget"
        :card-class="['card-grid']"
        :min-w="3"
        :min-h="minHeight"
        :resized="handleResized"
        @tab-widget-settings-click="handleTabWidgetSettingsClick"
    >
        <template v-slot:card-title>
            {{ title }}
        </template>
        <template v-slot:card-body>
            <card-grid
                ref="grid"
                :key="cardGridKey"
                :is-search="false"
                :columnDefs="columnDefs"
                :fetch-callback="fetchCallback"
                :pagination="true"
                :pagination-page-size="limit"
                :cache-block-size="limit"
                :is-auto-width="true"
                :font-size="tabWidget.settings.table_font_size"
            ></card-grid>
        </template>
        <template v-slot:tab-widget-settings-modal>
            <tab-widget-settings-modal-form
                :modal-id="tabWidgetSettingsModalID"
                :update="updateTabWidgetSettings"
                :initial-values="tabWidgetSettingsInitialValues"
                @success-update="handleSuccessTabWidgetSettingsUpdate"
                :withTableFontSize="true"
            ></tab-widget-settings-modal-form>
        </template>
    </card-grid-item>
</template>

<script>
import { AIRBNB_SYNC_ERROR_GRID_ENDPOINT } from '../../../../endpoints';
import API from '../../../../api';
import CardGrid from '../../../generic/card-grid/card-grid.vue';
import CardGridItem from '../common/card-grid-item.vue';
import { getWidgetGridRowsNumber } from '../helpers';
import TabWidgetSettingsModalForm from '../common/tab-widget-settings-modal-form.vue';
import cardGridItemBase from '../common/card-grid-item-base';

export default {
    name: 'AirbnbSyncErrorsTableCardGridItem',
    mixins: [cardGridItemBase],
    components: {
        CardGrid,
        CardGridItem,
        TabWidgetSettingsModalForm,
    },
    computed: {
        tabWidgetSettingsInitialValues() {
            return {
                settings: {
                    name: this.tabWidget.settings.name || this.defaultName,
                    table_font_size: this.tabWidget.settings.table_font_size || this.defaultWidgetFontSize,
                },
            };
        },
        fetchCallback() {
            return ({ offset, limit, sort, desc, search }) => {
                this.offset = offset;
                this.limit = limit;
                this.sort = sort;
                this.desc = desc;
                this.search = search;
                return API.get(AIRBNB_SYNC_ERROR_GRID_ENDPOINT(), {
                    params: {
                        offset,
                        limit,
                        sort,
                        desc,
                        search,
                    },
                });
            };
        },
    },
    data() {
        return {
            columnDefs: [
                {
                    field: 'id',
                    hide: true,
                },
                {
                    field: 'created',
                    headerName: 'Date',
                    type: 'dateTimeColumn',
                    sort: 'desc',
                    // minWidth: 200,
                },
                {
                    field: 'property_name',
                    headerName: 'Property',
                    // minWidth: 280,
                },
                {
                    field: 'url',
                    headerName: 'URL',
                    minWidth: 200,
                },
                {
                    field: 'error_message',
                    headerName: 'Message',
                    minWidth: 280,
                },
                {
                    field: 'error_details',
                    headerName: 'Details',
                    minWidth: 280,
                },
            ],
            offset: 0,
            limit: getWidgetGridRowsNumber({ tabWidget: this.tabWidget }),
            sort: 'id',
            desc: false,
            search: '',
        };
    },
    methods: {
        handleResized() {
            this.limit = getWidgetGridRowsNumber({ tabWidget: this.tabWidget });
            this.cardGridKey += 1;
        },
    },
};
</script>
